import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError, EXIT_VALIDATION_ERROR } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printSuccess } from '../../output.js'
import { confirm, isInteractive } from '../../lib/confirm.js'

export const projectsDeleteCommand = new Command(`delete`)
  .description(`Delete a project and all its environments`)
  .argument(`<id>`, `Project ID`)
  .option(`--force`, `Skip confirmation prompt`)
  .action(async (projectId: string, opts) => {
    const json = projectsDeleteCommand.parent?.parent?.opts().json ?? false
    try {
      if (!opts.force) {
        if (json) {
          process.stderr.write(
            JSON.stringify({
              error: `VALIDATION_ERROR`,
              message: `--force is required with --json`,
              exitCode: EXIT_VALIDATION_ERROR,
            }) + `\n`
          )
          process.exit(EXIT_VALIDATION_ERROR)
        }
        const confirmed = await confirm(
          `Delete project ${projectId}? This cannot be undone. [y/N] `
        )
        if (!confirmed) {
          if (!isInteractive()) {
            process.stderr.write(
              `Use --force to skip confirmation in non-interactive mode.\n`
            )
            process.exit(EXIT_VALIDATION_ERROR)
          }
          process.stderr.write(`Aborted.\n`)
          return
        }
      }

      const client = createClient()
      const result = await client.projects.delete({ projectId })

      if (isQuiet()) {
        printQuiet(projectId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Project ${projectId} deleted.`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
